import React from 'react'
import { Outlet } from 'react-router-dom'

function MainPayments() {
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default MainPayments;